import React, { FC, useCallback } from 'react';
import { Snackbar as BaseSnackbar, Slide } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';

import useSnackbarContext from './context/SnackbarContext';

const Snackbar: FC = () => {
  const { open, message, severity, remove } = useSnackbarContext();
  const { t } = useTranslation();
  const handleClose = useCallback(() => {
    remove();
  }, [remove]);

  return (
    <BaseSnackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={6000}
      onClose={handleClose}
      TransitionComponent={Slide}
    >
      <Alert severity={severity}>
        <AlertTitle>{t(`snackbar.${severity}`)}</AlertTitle>
        {message}
      </Alert>
    </BaseSnackbar>
  );
};

export default Snackbar;
